import React from "react";

export default function UploadMultipleImageIntroText({ multipleImageQrProps, style = {}, className = "" }) {
    const { introText, readOnly } = multipleImageQrProps;
    return (
        introText &&
        !readOnly && (
            <div
                className={className}
                style={{
                    maxWidth: "440px",
                    fontSize: "13px",
                    paddingTop: "24px",
                    fontWeight: 400,
                    textAlign: "center",
                    ...style,
                }}
            >
                {introText}
            </div>
        )
    );
}
